import { createClient } from '@supabase/supabase-js';

// Replace with your actual Supabase URL and anon key
const supabaseUrl = 'https://atupmriigzliwatrfeol.supabase.co';
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImF0dXBtcmlpZ3psaXdhdHJmZW9sIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTIxMjYzNTEsImV4cCI6MjA2NzcwMjM1MX0.QwE8c6At7JCMY5Cza5aSwmBcHGe-uBei9aX0jXei60o';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

// Database schema setup instructions:
/*
1. Create 'leads' table:
CREATE TABLE leads (
  id UUID DEFAULT gen_random_uuid() PRIMARY KEY,
  name VARCHAR(255) NOT NULL,
  phone VARCHAR(50) NOT NULL,
  email VARCHAR(255),
  website VARCHAR(255),
  company_name VARCHAR(255),
  company_address TEXT,
  company_city VARCHAR(100),
  company_postal_code VARCHAR(20),
  facebook VARCHAR(255),
  instagram VARCHAR(255),
  linkedin VARCHAR(255),
  service_requested VARCHAR(255),
  lead_source VARCHAR(100),
  notes TEXT,
  ai_reference_notes TEXT,
  status VARCHAR(50) DEFAULT 'New',
  created_at TIMESTAMP WITH TIME ZONE DEFAULT NOW(),
  updated_at TIMESTAMP WITH TIME ZONE DEFAULT NOW()
);

2. Create 'contacts' table:
CREATE TABLE contacts (
  id UUID DEFAULT gen_random_uuid() PRIMARY KEY,
  lead_id UUID REFERENCES leads(id) ON DELETE CASCADE,
  contact_type VARCHAR(50) NOT NULL, -- 'phone', 'email', 'sms'
  contact_date TIMESTAMP WITH TIME ZONE DEFAULT NOW(),
  subject VARCHAR(255),
  content TEXT,
  notes TEXT,
  created_at TIMESTAMP WITH TIME ZONE DEFAULT NOW()
);

3. Create 'app_settings' table:
CREATE TABLE app_settings (
  id UUID DEFAULT gen_random_uuid() PRIMARY KEY,
  setting_key VARCHAR(100) UNIQUE NOT NULL,
  setting_value TEXT,
  created_at TIMESTAMP WITH TIME ZONE DEFAULT NOW(),
  updated_at TIMESTAMP WITH TIME ZONE DEFAULT NOW()
);

4. Create 'company_info' table:
CREATE TABLE company_info (
  id UUID DEFAULT gen_random_uuid() PRIMARY KEY,
  company_name VARCHAR(255) NOT NULL,
  owner_name VARCHAR(255),
  address TEXT,
  city VARCHAR(100),
  state VARCHAR(100),
  postal_code VARCHAR(20),
  phone VARCHAR(50),
  email VARCHAR(255),
  website VARCHAR(255),
  created_at TIMESTAMP WITH TIME ZONE DEFAULT NOW(),
  updated_at TIMESTAMP WITH TIME ZONE DEFAULT NOW()
);

5. Authentication functions:

CREATE OR REPLACE FUNCTION handle_login_attempt(p_username TEXT, p_password TEXT)
RETURNS TABLE(success BOOLEAN, user_id UUID, user_role TEXT, message TEXT) AS $$
DECLARE
  v_user_id UUID;
  v_role TEXT;
  v_is_active BOOLEAN;
  v_stored_password TEXT;
  v_failed_attempts INT;
BEGIN
  -- Get user details
  SELECT id, role, is_active, password, failed_login_attempts 
  INTO v_user_id, v_role, v_is_active, v_stored_password, v_failed_attempts
  FROM users 
  WHERE username = p_username;
  
  -- User not found
  IF v_user_id IS NULL THEN
    RETURN QUERY SELECT false, NULL::UUID, NULL::TEXT, 'Invalid username or password'::TEXT;
    RETURN;
  END IF;
  
  -- Account inactive
  IF NOT v_is_active THEN
    RETURN QUERY SELECT false, NULL::UUID, NULL::TEXT, 'Account is inactive. Please contact administrator'::TEXT;
    RETURN;
  END IF;
  
  -- Verify password (using pgcrypto's crypt function)
  IF v_stored_password = crypt(p_password, v_stored_password) THEN
    -- Success! Reset failed attempts and update last login
    UPDATE users SET 
      failed_login_attempts = 0,
      last_login = NOW()
    WHERE id = v_user_id;
    
    RETURN QUERY SELECT true, v_user_id, v_role, 'Login successful'::TEXT;
  ELSE
    -- Failed login, increment counter
    UPDATE users SET 
      failed_login_attempts = COALESCE(failed_login_attempts, 0) + 1
    WHERE id = v_user_id;
    
    RETURN QUERY SELECT false, NULL::UUID, NULL::TEXT, 'Invalid username or password'::TEXT;
  END IF;
END;
$$ LANGUAGE plpgsql SECURITY DEFINER;

CREATE OR REPLACE FUNCTION change_password(p_user_id UUID, p_current_password TEXT, p_new_password TEXT)
RETURNS TABLE(success BOOLEAN, message TEXT) AS $$
DECLARE
  v_stored_password TEXT;
BEGIN
  -- Get stored password
  SELECT password INTO v_stored_password 
  FROM users 
  WHERE id = p_user_id;
  
  -- Verify current password
  IF v_stored_password = crypt(p_current_password, v_stored_password) THEN
    -- Update password
    UPDATE users SET 
      password = crypt(p_new_password, gen_salt('bf'))
    WHERE id = p_user_id;
    
    RETURN QUERY SELECT true, 'Password changed successfully'::TEXT;
  ELSE
    RETURN QUERY SELECT false, 'Current password is incorrect'::TEXT;
  END IF;
END;
$$ LANGUAGE plpgsql SECURITY DEFINER;

CREATE OR REPLACE FUNCTION create_user(p_username TEXT, p_password TEXT, p_email TEXT, p_full_name TEXT, p_role TEXT)
RETURNS TABLE(success BOOLEAN, user_id UUID, message TEXT) AS $$
DECLARE
  v_user_id UUID;
BEGIN
  -- Check if username already exists
  IF EXISTS (SELECT 1 FROM users WHERE username = p_username) THEN
    RETURN QUERY SELECT false, NULL::UUID, 'Username already exists'::TEXT;
    RETURN;
  END IF;
  
  -- Insert new user
  INSERT INTO users (username, password, email, full_name, role)
  VALUES (
    p_username,
    crypt(p_password, gen_salt('bf')),
    p_email,
    p_full_name,
    COALESCE(p_role, 'user')
  ) RETURNING id INTO v_user_id;
  
  RETURN QUERY SELECT true, v_user_id, 'User created successfully'::TEXT;
END;
$$ LANGUAGE plpgsql SECURITY DEFINER;

CREATE OR REPLACE FUNCTION admin_reset_password(p_user_id UUID, p_new_password TEXT)
RETURNS BOOLEAN AS $$
BEGIN
  UPDATE users SET 
    password = crypt(p_new_password, gen_salt('bf'))
  WHERE id = p_user_id;
  
  RETURN FOUND;
END;
$$ LANGUAGE plpgsql SECURITY DEFINER;

6. Create default admin user:
INSERT INTO users (username, password, email, full_name, role, is_active)
SELECT 'admin', crypt('mypassword1234', gen_salt('bf')), 'admin@example.com', 'System Administrator', 'admin', true
WHERE NOT EXISTS (SELECT 1 FROM users WHERE username = 'admin');

7. Enable Row Level Security (RLS) on all tables if needed

8. Add website column to existing leads table (if upgrading):
ALTER TABLE leads ADD COLUMN IF NOT EXISTS website VARCHAR(255);
*/